class OutOfServicePhone {
  constructor(note, totalDuration, phoneId) {
    this.note = note;
    this.totalDuration = totalDuration;
    this.phoneId = phoneId;
  }
}
export default {
  OutOfServicePhone,
};
